<template>
  <div class="pb-4">
    <div class="child-row__title pb-4">Messages from carrier / recipient</div>

    <CarrierMessagesTable :detailed="false" :base-filter="baseFilter" />
  </div>
</template>

<script lang="ts">
import type { Shipment } from '@/types/Models/Shipment'
import { computed, defineComponent, type PropType } from 'vue'
import CarrierMessagesTable from '@/views/Components/CarrierMessages/CarrierMessagesTable.vue'

export default defineComponent({
  name: 'CarrierMessages',
  components: {
    CarrierMessagesTable,
  },
  props: {
    shipment: {
      type: Object as PropType<Shipment>,
      required: true,
    },
  },
  setup(props) {
    const baseFilter = computed(() => ({ 'item[]': props.shipment.id }))

    return {
      baseFilter,
    }
  },
})
</script>
